import { render, staticRenderFns } from "./IconTypeformGroup.vue?vue&type=template&id=20ec23ea&"
import script from "./IconTypeformGroup.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports